<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/Analyse' }" replace>作业分析报告</el-breadcrumb-item>
				<el-breadcrumb-item :to="{ path: '/AnalyseGeneral' ,query:{id:this.$route.query.id}}" replace>查看详情</el-breadcrumb-item>
				<el-breadcrumb-item>题目分析</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="p_m_t_30 public_box overflow" :style="{ height: height + 'px' }">
			<div class="p_m_l_60 p_m_r_60 public_padding " :class="[ !show?'heagt':'']" v-for="(item,index) in counts" :key="index">
				<div class="p_flex p_f_a p_f_b">
					<div class="p_flex p_f_a">
						<el-tag type="success" size="small " effect="dark">{{item.pass==1?"优秀":item.pass==2?"良好":item.pass==3?"及格":"不及格"}}</el-tag>
						<div class="p_m_l_20"><el-tag type="success" size="small " effect="dark">{{item.total_score}}分</el-tag></div>
						<span class="type_size_22 p_m_l_20">{{item.job_name}}</span>
					</div>
					<div v-if="item.job_type == 2">
						<el-button type="warning" v-if="show" @click='show = false'>看试卷</el-button>
						<el-button type="warning" v-if="!show" @click='show = true'>返回</el-button>
					</div>
				</div>
				<div id="" v-if="show">
					<div class="p_flex p_f_a   p_m_t_20 type_size_18">
						<div class="p_flex center p_f_1">
							<span class="subject_color">{{item.classLevel.name}}</span>
							<el-divider direction="vertical"></el-divider>
							<span class="subject_yellow">{{item.student_name}}</span>
							<el-divider direction="vertical"></el-divider>
							<span>用时  {{ formatTime(item.use_secs)}}</span>
						</div>
					</div>
					<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
						<div class="p_flex ">正确率</div>
						<div class="p_f_1 p_m_l_20  p_m_r_20">
							<el-progress :text-inside="true" :show-text="false" color="#00AF63" :stroke-width="20" :percentage="item.exact_rate" status="success"></el-progress>
						</div>
						<span class="p_f_1">{{item.exact_rate}}%</span>
					</div>
					<div class="p_m_t_30 type_size_22 subject_color">全部题目</div>
				</div>
				<div id="" v-if="!show" style="height: 100%;">
					<view-picture v-if="item.jobPublish.exercise_book_file_type == 3" :url="item.jobPublish.exercise_book_file_url"></view-picture>
					<view-iform v-if="item.jobPublish.exercise_book_file_type == 1" :url="item.jobPublish.exercise_book_file_url"></view-iform>
					<view-iform v-if="item.jobPublish.exercise_book_file_type == 2" :url=" 'https://view.officeapps.live.com/op/view.aspx?src=' + item.jobPublish.exercise_book_file_url"></view-iform>
				</div>
			</div>
			<div v-if="show" class="p_m_l_60 p_m_r_60">
				<deatils-list></deatils-list>
			</div>

		</div>
	</div>
</template>

<script>
import DeatilsList from './commponents/deatilslist.vue';
import ViewIform from './commponents/iform.vue'
import ViewPicture from './commponents/picture.vue'
export default {
	name: 'AnalyseDeatils',
	components:{
		DeatilsList,
		ViewPicture,
		ViewIform
	},
	data() {
		return {
			height: 0,
			counts:[],
			show:true
		};
	},
	mounted() {
		this.indexInfo();
	},
	created() {
		// console.log(this.$route.query.id)   // 作业id
		// console.log(this.$route.query.ids) //学生id
		this.$request.ajax(this).post("/api_teacher/analysis_student_job_detail",{
			job_publish_id: this.$route.query.id,
			student_id:this.$route.query.ids
		}).then(res=>{
			// console.log(res)
			this.counts.push(res.data)
		})
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/AnalyseDeatils') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	methods: {
		formatTime(second) {
			function padStart(num) {
				return (num|0).toString().padStart(2,'0')
			}

			return padStart(second/60/60)+':'+padStart(second/60%60)+':'+padStart(second%60)
		},
		// get(){
		// 	this.$request.ajax(this).post("/api_teacher/analysis_report",{
        //    		job_publish_id: this.$store.state.nameid
		// 	}).then(res=>{
		// 		// console.log(res)
		// 	})
		// },
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	}
};
</script>

<style lang="scss" scoped>
.public_box {
	background-color: #ffffff;
}

.public_padding {
	padding: 30px 0;
}

>>> .el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
.heagt{
	height: 100%;;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/analyse/deatils.vue